import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { QUESTIONS } from "../data/questions";
import SEOHead from "../components/SEOHead";

export default function Quiz({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState([]);
  const [selectedIdx, setSelectedIdx] = useState(null);
  const [locked, setLocked] = useState(false);

  const q = QUESTIONS[index];
  const progress = ((index + (selectedIdx != null ? 1 : 0)) / QUESTIONS.length) * 100;

  const handlePick = (optIdx) => {
    if (locked) return;
    setLocked(true);
    setSelectedIdx(optIdx);
    // ~220ms highlight, then advance.
    window.setTimeout(() => {
      const nextAnswers = [...answers, optIdx];
      setAnswers(nextAnswers);
      if (index + 1 >= QUESTIONS.length) {
        onComplete(nextAnswers);
      } else {
        setIndex(index + 1);
        setSelectedIdx(null);
        setLocked(false);
      }
    }, 260);
  };

  return (
    <div className="relative z-10 min-h-[100dvh]" data-testid="quiz-screen">
      <SEOHead noindex path="/quiz" title="Quiz" />
      <div className="progress-track" aria-hidden>
        <div
          className="progress-fill"
          style={{ width: `${progress}%` }}
          data-testid="progress-fill"
        />
      </div>

      <div className="mx-auto flex min-h-[100dvh] w-full max-w-md flex-col px-6 pt-16 pb-12">
        <p
          className="mb-8 text-[11px] font-medium uppercase"
          style={{ color: "var(--muted)", letterSpacing: "0.32em" }}
          data-testid="question-counter"
        >
          Question {index + 1} / {QUESTIONS.length}
        </p>

        <AnimatePresence mode="wait">
          <motion.div
            key={q.id}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          >
            <h2
              className="font-serif text-[26px] leading-[1.25] sm:text-[30px]"
              style={{ color: "var(--text)" }}
              data-testid="question-text"
            >
              {q.text}
            </h2>

            <div className="mt-8 flex flex-col gap-3">
              {q.options.map((opt, i) => (
                <button
                  key={`${q.id}-${i}`}
                  data-testid={`option-card-${i}`}
                  className={`option-card ${selectedIdx === i ? "selected" : ""}`}
                  onClick={() => handlePick(i)}
                  disabled={locked}
                >
                  {opt.text}
                </button>
              ))}
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
